export default __webpack_public_path__ + "static/media/news32.88d1034e.jpg";